exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TraceTool-ec14f5c4 p{margin-bottom:10px}.status-b8265ccb{animation:statusblink-ef263e70 0.7s ease-in-out infinite}@keyframes statusblink-ef263e70{50%{opacity:0.5}}\n", ""]);

// Exports
exports.locals = {
	"TraceTool": "TraceTool-ec14f5c4",
	"status": "status-b8265ccb",
	"statusblink": "statusblink-ef263e70"
};